<template>
  <div v-bind:is="component">
    <!-- パンくずリスト -->
    <CreatePlusBreadcrumbs 
      v-bind:categoryid="categoryid" 
      v-bind:subcategoryid="subcategoryid" 
      v-bind:templateid="templateid" />
    <!-- /パンくずリスト -->

    <div class="container">
    <!-- サムネイルコンテンツ表示範囲 -->
    <div id="templatewrapper">
      <div class="row">
        <!-- テンプレートサムネイル画像 -->
        <CreatePlusTemplateSlide 
          v-bind:categoryid="categoryid"
          v-bind:subcategoryid="subcategoryid"
          v-bind:templateid="templateid" />
        <!-- / テンプレートサムネイル画像 -->
        <!-- テンプレート情報 -->
        <CreatePlusTemplate 
          v-bind:categoryid="categoryid"
          v-bind:subcategoryid="subcategoryid"
          v-bind:templateid="templateid" />
        <!-- テンプレート情報 -->
      </div>
    </div>
    <!-- サムネイルコンテンツ表示範囲 -->
    </div>
    <!-- /container -->
  </div>
  <!-- /fun_container -->

</template>

<script>
import CreatePlusBreadcrumbs from '../components/CreatePlusBreadcrumbs'
import CreatePlusTemplateSlide from '../components/CreatePlusTemplateSlide'
import CreatePlusTemplate from '../components/CreatePlusTemplate'
import CreatePlusTop from "./CreatePlusTop";
export default {
  name: "CreatePlusTemplatePage",
  props: {
    categoryid: String,
    subcategoryid: String,
    templateid: String,
  },
  components: {
    CreatePlusBreadcrumbs,
    CreatePlusTemplateSlide,
    CreatePlusTemplate
  },
  computed: {
    component: function() {
      const category = this.$store.state.createplusTemplates.createplusCategories.find((category) => {
        return category.categoryID === this.categoryid;
      });
      let subcategory = null;
      if (category) {
        subcategory = category.subCategories.find((subcategory) => {
          return subcategory.subCategoryID === this.subcategoryid;
        });
      }
      const template = this.$store.state.createplusTemplates.createplusTemplates.find((template) => {
        return template.templateID === this.templateid;
      });
      if (category && subcategory && template) {
        return "div";
      }
      return CreatePlusTop;
    }
  },
  metaInfo() {
    return {
      title: "Epson Setup Navi",
      meta: [
        {
          name: "description",
          content: this.$store.state.messages.messages["0-141"],
        },
      ],
      link: [
        {
          rel: "stylesheet",
          href:
            process.env.VUE_APP_ROOT + "/assets/createplus/css/createplus.css",
        },
        {
          rel: "stylesheet",
          href: "https://maxcdn.bootstrapcdn.com/font-awesome/4.3.0/css/font-awesome.min.css",
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>